export default {"src":"/_next/static/media/Logo_efigas_full.49db4088.svg","height":366,"width":761,"blurWidth":0,"blurHeight":0};